import { noOp, SearchType } from '../common';

// == Navigator ================================================================

export interface Url {
  baseUrl?: string;
  path: string;
}

export interface InstantSearchMonitoringData {
  instantSearchPrice?: string;
  airCalendarPrice?: string;
}

export interface Navigator {
  navigateToBooking: (url: Url, instantSearchMonitoringData?: InstantSearchMonitoringData) => any;
  /**
   * Award tab navigation to login page, mandatory if award is enabled
   */
  navigateToLogin: () => void;
  /**
   * Award tab navigation to join page, mandatory if award is enabled
   */
  navigateToJoin: () => void;
}

// == GtmService ===============================================================

export enum GtmTripType {
  ONEWAY = 'ONEWAY',
  RETURN = 'RETURN',
}

export enum GtmTravelClass {
  ECONOMY = 'ECONOMY',
  BUSINESS = 'BUSINESS',
  MIXED = 'MIXED',
}

export interface GtmPassengers {
  adults: number;
  children: number;
  infants: number;
}

export enum GtmEvent {
  PAGE_VIEW = 'pageView',
  UI_EVENT = 'uiEvent',
}

export interface GtmUiEventData {
  context: 'flight-search' | 'flight-search-aurinkomatkat';
  triggerElement: 'BOOKING_WIDGET';
  id: string;
  state: string;
  language: string;
  pagePath: string;
  searchType?: SearchType;
}

export interface GtmFlightSearchData {
  origin: string;
  destination: string;
  start?: string;
  end?: string;
  tripType: GtmTripType;
  travelClass: GtmTravelClass;
  passengers: GtmPassengers;
}

export interface GtmPageViewData {
  path: string;
  language: string;
  pointOfSale: string;
}

export type GtmEventData = GtmUiEventData | GtmFlightSearchData | GtmPageViewData;

export interface GtmTrackElementData {
  elementName: string;
  elementType: string;
  context: string;
  state: string;
  searchType?: SearchType;
}

export interface GtmService {
  log: (event: GtmEvent, eventData: GtmEventData) => void;
  trackElement?: (eventData: GtmTrackElementData) => void;
}

export interface RecommendationService {
  sendFlightSearchEvent: (
    departureDate: string,
    returnDate?: string,
    originAirpot?: string,
    destinationAirport?: string,
    originCity?: string,
    destinationCity?: string,
    paxAdults?: number,
    paxChildren?: number
  ) => void;
}

// == ExtensionApi =============================================================

export interface ExtensionApi {
  navigator: Navigator;
  gtmService: GtmService;
  recommendationService: RecommendationService;
  getLoginToken?: () => string;
}

export const defaultExtensionApi: ExtensionApi = {
  navigator: {
    navigateToBooking: ({ baseUrl, path }: Url): void => {
      window.location.href = `${baseUrl}${path}`;
    },
    navigateToJoin: noOp,
    navigateToLogin: noOp,
  },
  gtmService: {
    log: noOp,
    trackElement: noOp,
  },
  recommendationService: {
    sendFlightSearchEvent: noOp,
  },
};
